<template>
  <dl class="shop" v-if="list.length">
    <dt class="shop-header">发现好店</dt>
    <dd class="shop-list">
      <a
        class="shop-item"
        v-for="(item, i) in list"
        :key="i"
        target="_blank"
        :href="`/detail/${item.property.topics[0].englishName}/${item.id}`"
      >
        <YorkbbsImage class="shop-cover" animation :src="item.property.coverImage | webpFormat(250)"></YorkbbsImage>
        <div class="shop-title e">{{ item.title }}</div>
        <div class="shop-subtitle">{{ item.property.extend1 }}</div>
      </a>
    </dd>
  </dl>
</template>
<script>
export default {
  name: 'PcShop',
  components: {},
  data() {
    return {
      loading: false,
      list: [],
    };
  },
  created() {
    this.getGoodPosts();
  },
  methods: {
    async getGoodPosts() {
      this.loading = true;
      const { data } = await this.$axios.post('/info/v1/get/mainpage/good/post', { offset: 1, size: 8 }).finally(() => {
        this.loading = false;
      });
      this.list = data.items;
    },
  },
};
</script>
<style lang="scss" scoped>
.shop {
  margin-top: 30px;
}
.shop-header {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  margin-bottom: 20px;
}
.shop-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
  margin-right: -10px;
}
.shop-item {
  box-sizing: border-box;
  padding: 10px;
  width: 260px;
  border-radius: 4px;
  &:nth-child(n + 5) {
    margin-top: 30px;
  }
  &:not(:nth-child(4n)) {
    margin-right: 43.333333333333336px;
  }
  &:hover {
    box-shadow: 0 15px 20px rgba($color: #000000, $alpha: 0.1);
  }
}
.shop-cover {
  box-sizing: border-box;
  width: 100%;
  height: 188px;
  border-radius: 4px;
  border: 1px solid #f8f8f8;
}
.shop-title {
  font-size: 16px;
  color: var(--text-color-3);
  line-height: 22px;
  margin-top: 12px;
  &:hover {
    color: var(--primary-color);
  }
}

.shop-subtitle {
  font-size: 14px;
  color: var(--text-color-9);
  line-height: 20px;
  margin-top: 6px;
  display: inline-block;
}
</style>
